import type { ApiError } from '@/types/common'

export function simulateLatency(min = 300, max = 800): Promise<void> {
  const delay = min + Math.random() * (max - min)
  return new Promise((resolve) => setTimeout(resolve, delay))
}

const GENERIC_ERROR: ApiError = {
  code: 'network_error',
  message: 'Conexiunea a eșuat. Verifică internetul și încearcă din nou.',
}

/** Throws a generic ApiError at the configured VITE_MOCK_ERROR_RATE, for demoing error/retry states. */
export function maybeThrowMockError(): void {
  const rate = Number(import.meta.env.VITE_MOCK_ERROR_RATE ?? 0)
  if (rate > 0 && Math.random() < rate) {
    throw GENERIC_ERROR
  }
}
